import * as React from 'react'
import isEmail from 'validator/lib/isEmail'
import classNames from 'classnames'

import InputField from '../00-Primitives/Inputs/InputField'
import Paragraph from 'content-components/_Primatives/Paragraph'
import Submit from '../00-Primitives/Inputs/Submit'

import style from './style.scss'

export type Props = {
  className?: string
  descriptionText: string
  emailLabelText: string
  emailMeButtonText: string
  emailPlaceholderText: string
  invalidEmailText: string
  onSubmitEmail: (email: string) => Promise<void>
  submitErrorText: string
  successText: string
}

type State = {
  email: string
  hasSubmitError: boolean
  isSubmitting: boolean
  submitted: boolean
  validEmail: boolean
}

class EmailOfTheDay extends React.PureComponent<Props, State> {
  static defaultProps = {
    className: '',
  }

  state = {
    email: '',
    hasSubmitError: false,
    isSubmitting: false,
    submitted: false,
    validEmail: true,
  }

  handleUpdateEmail = (email: string) => this.setState({ email })

  handleSubmitEmail = async (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
    const { onSubmitEmail } = this.props
    const { email, validEmail, isSubmitting } = this.state

    /* Check if the email is valid before proceeding
     * If it is invalid, set validEmail to false to display error msg
     * If valid, submit email to backend for further processing
     * and set submitted state to true
     */
    if (isSubmitting) {
      return
    }

    if (!isEmail(email)) {
      this.setState({ validEmail: false })
      return
    } else if (!validEmail) {
      this.setState({ validEmail: true })
    }

    this.setState({ isSubmitting: true })

    try {
      await onSubmitEmail(email)
      this.setState({ submitted: true, validEmail: true, isSubmitting: false })
    } catch {
      return this.setState({
        submitted: false,
        hasSubmitError: true,
        isSubmitting: false,
      })
    }
  }

  render() {
    const {
      className,
      descriptionText,
      emailLabelText,
      emailMeButtonText,
      emailPlaceholderText,
      invalidEmailText,
      submitErrorText,
      successText,
    } = this.props
    const { email, hasSubmitError, submitted, validEmail } = this.state
    return (
      <div className={classNames(style.wrapper, className)}>
        <Paragraph className={style.descriptionText} small>
          {descriptionText}
        </Paragraph>
        {!submitted ? (
          <form className={style.form} onSubmit={this.handleSubmitEmail}>
            <InputField
              className={style.emailInput}
              inputId='email-of-the-day'
              isLabelHidden
              label={emailLabelText}
              placeholder={emailPlaceholderText}
              value={email}
              onUpdateField={this.handleUpdateEmail}
            />
            <Submit
              className={style.submitButton}
              submitText={emailMeButtonText}
              variant='secondaryBlue'
            />
            {(!validEmail || hasSubmitError) && (
              <Paragraph className={style.errorMessage} small>
                {!validEmail ? invalidEmailText : submitErrorText}
              </Paragraph>
            )}
          </form>
        ) : (
          <Paragraph className={style.successMessage} small>
            {successText}
          </Paragraph>
        )}
      </div>
    )
  }
}

export default EmailOfTheDay
